import { Button } from '@mui/material';
import { useContext } from 'react';

import { colors } from '@/colors';
import { Container } from '@/components/Container';
import { OrderContext } from '@/contexts/OrderContext';
import useTranslation from '@/hooks/useTranslation';

interface IOrderApproveDeclineButtonsProps {
  orderId: string;
  isOrderDeclined?: boolean;
}

export const OrderApproveDeclineButtons = ({ orderId, isOrderDeclined = false }: IOrderApproveDeclineButtonsProps) => {
  const t = useTranslation();
  const { startOrderApprove } = useContext(OrderContext);

  return (
    <Container debugColor={'tomato'} sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Container
        debugColor={'rosybrown'}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '12px',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          flexWrap: 'wrap',
        }}
      >
        <Button
          onClick={() => {
            startOrderApprove(orderId, true);
          }}
          sx={{ backgroundColor: colors.success, fontSize: 'min(12px, 3dvw)' }}
        >
          {t('order.approve')}
        </Button>
        {!isOrderDeclined && (
          <Button
            onClick={() => {
              startOrderApprove(orderId, false);
            }}
            sx={{ backgroundColor: colors.error, fontSize: 'min(12px, 3dvw)' }}
          >
            {t('order.decline')}
          </Button>
        )}
      </Container>
    </Container>
  );
};
